export const erdMermaidChart = `erDiagram
    users ||--o{ books : "penulis / author_id"
    users ||--o{ books : "penerbit / publisher_id"
    users ||--o{ notifications : "user_id"
    users ||--o{ posts : "author_id"
    blog_categories ||--o{ posts : "category_id"
    books ||--o{ scans : "book_id"
    books ||--o{ notifications : "book_id"
    books ||--o{ books : "parent_book_id (Silsilah Edisi)"

    users {
        string id PK
        string name
        string email UK
        string password
        string role "admin | penerbit | penulis"
        string organization
        string publisher_code "Kode 4 Digit (8042)"
        int is_publisher_verified "0 | 1"
        string publisher_verification_status "unverified | pending | verified | rejected"
        string publisher_legal_name
        string publisher_nib
        string publisher_phone
        string publisher_address
        string publisher_website
        string profile_image_url "Cloudflare R2 URL"
        string created_at
    }

    books {
        string id PK
        string uibn UK "Kode UIBN (UIBN-979-...)"
        string title
        string subtitle
        string original_title
        string author_name
        string author_id FK
        string author_whatsapp
        string publisher_name
        string publisher_id FK
        string category "000-900 (Dewey Decimal)"
        int publication_year
        string edition
        int pages
        string language
        string isbn_original
        string synopsis
        string table_of_contents
        string cover_url "Cloudflare R2 / WebP URL"
        string purchase_url
        string status "draft | diajukan | disetujui | diarsipkan"
        string parent_book_id FK "Edisi Induk"
        string root_book_id FK "Edisi Akar Silsilah"
        string edition_type "orisinal | revisi | cetakan_baru | digital | terjemahan"
        string edition_notes
        string submission_source "penulis | penerbit"
        string created_at
        string updated_at
    }

    scans {
        string id PK
        string book_id FK
        string uibn
        string scan_method "barcode_scanner | qr_scanner | manual_input"
        string user_agent
        string ip_address
        string scanned_at
    }

    notifications {
        string id PK
        string user_id FK
        string book_id FK
        string title
        string message
        string type "status_change | system | scan_alert"
        int is_read "0 | 1"
        string created_at
    }

    posts {
        string id PK
        string title
        string slug UK
        string content
        string summary
        string author_id FK
        string author_name
        string author_bio
        string author_role
        string status "draft | published"
        string subtitle
        int likes
        string tags
        string category
        string category_id FK
        int is_featured "0 | 1"
        string published_at
        string created_at
        string updated_at
    }

    blog_categories {
        string id PK
        string name
        string slug UK
        string description
        string color
        string created_at
        string updated_at
    }

    system_settings {
        string id PK
        string key UK "r2_config | system_params"
        string value "JSON String (Credentials / Config)"
        string updated_at
    }
`;

export const architectureMermaidChart = `graph TD
    Client[Aplikasi Web React / SPA] -->|HTTP REST / JWT| Hono[Server Framework Hono]
    Hono -->|Authentication & AuthZ| Auth[Middlewares Auth & RBAC]
    
    Hono -->|Modulo IAM| UsersModule[Module Users / IAM]
    Hono -->|Modulo Books| BooksModule[Module Books Catalog]
    Hono -->|Modulo Editions| EditionsModule[Module Edition Lineage]
    Hono -->|Modulo Telemetry| ScansModule[Module Scans & Stats]
    Hono -->|Modulo Notifications| NotifModule[Module Notifications]
    Hono -->|Modulo Blog| BlogModule[Module Blog & Newsletter]
    Hono -->|Modulo R2 Storage| R2Service[R2UploadService]
    
    BooksModule -->|ORM Query| Drizzle[Drizzle ORM Engine]
    UsersModule -->|ORM Query| Drizzle
    EditionsModule -->|ORM Query| Drizzle
    ScansModule -->|ORM Query| Drizzle
    BlogModule -->|ORM Query| Drizzle
    
    BooksModule -->|Unggah/Hapus Cover| R2Service
    UsersModule -->|Unggah/Hapus Foto Profil| R2Service
    R2Service -->|AWS S3 Protocol| CloudflareR2[(Cloudflare R2 Object Storage)]
    
    BooksModule -->|Full-Text Search| FTS5[SQLite Virtual Table FTS5]
    Drizzle -->|LibSQL / SQLite Driver| SQLite[(Database SQLite UIBN)]
`;
